import React from 'react';

const SLATE = '#0B1426';
const CORAL = '#FF4E6A';
const MUTED = '#5B6577';
const RULE  = 'rgba(11,20,38,0.10)';

/* Compact horizontal stage timeline shown inside the AG + Hale detail
 * panels. Stages are computed from the live state machine so the
 * timeline reflects exactly what the brand / Hale / AG see. */
export default function AuditTimeline({ stages, currentIndex, testid = 'audit-timeline' }) {
  return (
    <div
      className="rounded-sm border px-4 py-3"
      style={{ borderColor: RULE, backgroundColor: 'rgba(255,255,255,0.5)' }}
      data-testid={testid}
    >
      <p className="text-[10px] font-mono uppercase tracking-[0.3em] mb-2.5" style={{ color: MUTED }}>
        Audit trail
      </p>
      <ol className="flex items-center flex-wrap gap-x-1.5 gap-y-2">
        {stages.map((label, i) => {
          const done = i < currentIndex;
          const cur  = i === currentIndex;
          const color = cur ? CORAL : done ? SLATE : MUTED;
          const dotFill = cur ? CORAL : done ? SLATE : 'transparent';
          return (
            <li key={label} className="flex items-center gap-1.5">
              <span
                className="inline-block w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: dotFill, border: `1px solid ${color}` }}
                aria-hidden="true"
              />
              <span
                className="text-[11px] font-mono uppercase tracking-[0.16em]"
                style={{ color, fontWeight: cur ? 700 : 500 }}
              >
                {label}
              </span>
              {i < stages.length - 1 && (
                <span className="text-[11px]" style={{ color: MUTED }}>→</span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

/* Compute the current stage index for the AG-side timeline. */
export function agStageIndex(app) {
  const ag = app?.ag?.ag_status;
  const hale = app?.hale?.hale_status;
  // Stages: Intake Received → Document Review → Scientific Review → Recommendation Complete → Routed to Hale
  if (hale === 'ag_recommendation_received' || hale === 'hale_approved' ||
      hale === 'hale_rejected' || hale === 'hale_hold' || hale === 'badge_issued') return 4;
  if (ag === 'scientific_output_complete' || ag === 'recommended' ||
      ag === 'recommended_with_conditions' || ag === 'not_recommended') return 3;
  if (ag === 'scientific_review') return 2;
  if (ag === 'document_review' || ag === 'additional_information_required') return 1;
  return 0;
}

/* Compute the current stage index for the Hale-side timeline. */
export function haleStageIndex(app) {
  const hale = app?.hale?.hale_status;
  // Stages: Submitted → AG Review → AG Output Complete → Hale Decision Pending → Badge Issued
  if (hale === 'badge_issued') return 4;
  if (hale === 'hale_approved' || hale === 'hale_hold' || hale === 'hale_rejected') return 3;
  if (hale === 'ag_recommendation_received' || hale === 'hale_decision_pending') return 3;
  const ag = app?.ag?.ag_status;
  if (ag === 'scientific_output_complete' || ag === 'recommended' ||
      ag === 'recommended_with_conditions' || ag === 'not_recommended') return 2;
  if (ag === 'document_review' || ag === 'scientific_review' || ag === 'additional_information_required') return 1;
  return 0;
}
